import { A as h } from "./abort.js";
import { b as m, w as p } from "./helpers.js";
async function u(r, e, c) {
  const {
    signal: a,
    attempts: f = 5,
    shouldRetry: i,
    timeout: t
  } = x(e, c);
  let s = 0;
  for (; ; )
    try {
      return s++, await r();
    } catch (n) {
      if (h.is(n) || s === f || a != null && a.aborted || (i == null ? void 0 : i({ error: n, attempt: s })) === !1)
        throw n;
      const w = (t == null ? void 0 : t.start) ?? 3e3, y = (t == null ? void 0 : t.delta) ?? 1e3, b = (t == null ? void 0 : t.max) ?? 1 / 0, o = Math.min(w + s * y, b);
      a ? await m(a, o) : await p(o);
    }
}
function x(r, e) {
  return r ? r instanceof AbortSignal ? { signal: r, attempts: e } : r : { attempts: e };
}
export {
  u as r
};
//# sourceMappingURL=retry.js.map
